<template>
    <div v-if="basketRights" class="basketContainer iBlock vMid rel">
        <div class="basketMenu iBlock vMid pointer" @click.stop="toggleMenuState();">
            <span class="countBasket">{{ countAllBaskets }}</span>
            <span class="basketMenuTitle rel">
                <span class="panel">{{ $t("basketMenu.menuTitle") }}</span> <i class="fas fa-shopping-basket"></i>
            </span>
        </div>
        <BasketWindow v-if="menuIsOpened"></BasketWindow>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import BasketWindow from "./BasketWindow";

export default {
    name: "BasketMenu",
    components: { BasketWindow },
    computed: {
        ...mapGetters("basket", {
            countAllBaskets: "list/countAllBaskets",
            menuIsOpened: "menu/menuIsOpened",
            menuIsActive: "menu/menuIsActive"
        }),
        basketRights() {
            return this.hasClientAccess("orders_manager", this.AccessUser.ACTION.READ);
        }
    },
    methods: {
        ...mapActions("basket", {
            populateBasketList: "list/populateBasketList",
            toggleMenuState: "menu/toggleMenuState"
        })
    },
    mounted() {
        this.populateBasketList();
    }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/themes.scss";

.basketContainer {
    * {
        text-transform: none;
    }
    .basketMenu {
        padding: 0;
        color: #fff;
        @media only screen and (max-width: 992px) {
            text-align: center;
        }
        > * {
            background-color: $color4;
        }
        .countBasket {
            display: inline-block;
            vertical-align: middle;
            text-align: center;
            padding: 7px 12px;
            overflow: hidden;
            border-radius: 50%;
            font-size: 18px;
        }
        .basketMenuTitle {
            position: relative;
            right: 9px;
            border-radius: 15px;
            padding: 5px 5px;
            padding-left: 5px;
            font-size: 12px;
            border-bottom-left-radius: 0px;
            border-top-left-radius: 0px;
            @media only screen and (max-width: 992px) {
                display: block;
                border-radius: 15px;
                right: 0;
                top: -10px;
            }
            svg {
                @media only screen and (max-width: 992px) {
                    /*display: none;*/
                }
            }
            & .panel {
                text-transform: uppercase;
                font-size: 11px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// BasketMenu.vue?699fa794